import {
  apiDelete,
  apiGet,
  apiPatch,
  apiPost,
  apiPut,
  getCurrentUserId,
} from "../../../utils";

export function getQueryFormatAPI(extra) {
  const data = { userId: getCurrentUserId(), ...extra };
  return apiGet(`/api/clientQuery`, data);
}

export function queryByIdAPI(id) {
  return apiGet(`/api/clientQuery/${id}`);
}

export function queryByPDFdownloadAPI(id) {
  return apiGet(`/api/clientQuery/pdfdownload/${id}`);
}

export function cargoByQueryAPI(id) {
  return apiGet(`/api/clientQuery/${id}`);
}

export function allCargoExtraDetailsByQueryAPI(id) {
  const data = { id: id };
  return apiGet(`/api/v1/allCargoExtraDetailsByQuery`, data);
}

export function allFleetAPI() {
  return apiGet(`/api/fleet/getAllFleet`);
}

export function allFleetCalculatorAPI(data) {
  return apiGet(`/api/fleet/getAllFleetForCacl?offset=${data.offset}&perPage=${data.perPage}`);
}

export function getSingleVesselCalcyAPI(data) {
  return apiGet(`/api/calculatedCost/getSingleVesselCalcy/${data?.queryid}/${data?.vesselid}`);
}

export function sendCalculatorDataAPI(data) {
  return apiPost(`/api/clientQuery/calculate/cargoPrice`, data);
}

export function addCargoExtraDetailsAPI(data) {
  return apiPost(
    `/api/clientQuery/cargoList/addCargo/${data.queryId}`,
    data
  );
}

export function addCargoExtraDetailsForCargoAnalysisAPI(data) {
  return apiPost(
    `/api/cargoAnalysis/cargoList/addCargo/${data.queryId}`,
    data
  );
}

export function addCargoExtraDetailsForSingleVesselAPI(data) {
  return apiPost(
    `/api/calculatedCost/cargoList/addCargo/${data.calculatedCostId}`,
    data
  );
}

export function updateQueryFormtAPI(data) {
  return apiPut(`/api/v1/updateQueryFormt`, data);
}

export function deleteCargoExtraDetailAPI(data) {
  return apiDelete(`/api/clientQuery/${data.queryId}/${data.cargoId}`);
}
export function deleteCargoExtraDetailFromCargoAnalysisAPI(data) {
  return apiDelete(`/api/cargoAnalysis/deleteCargoExtraDetails/${data.queryId}/${data.cargoId}`);
}
export function deleteCargoExtraDetailForSingleVesselAPI(data) {
  return apiDelete(`/api/calculatedCost/${data.calculatedCostId}/${data.cargoId}`);
}

export function updateQueryFormatAPI(data) {
  return apiPut(`/api/v1/updateQueryFormat`, data);
}

export function updateQueryAPI(data) {
  const formData = new FormData();

  formData.append('QueryData', JSON.stringify(data) || '');

  return apiPut(`/api/clientQuery/${data._id}`, formData);
}

export function updateQueryCalculatedCostAPI(id, data) {
  return apiPut(`/api/calculatedCost/${id}`, data);
}

export function updateClientQueryAccessAPI(data) {
  return apiPut(`/api/clientQuery/access/${data.id}`, { access: data.access });
}

export function updateChangeSwitchQueryAPI(data) {
  return apiPut(`/api/clientQuery/switch/${data.id}`, { isShowInCalculator: data.isShowInCalculator });
}

export function deleteFleetAPI(id) {
  return apiDelete(`/api/fleet/${id}`);
}

export const allVesselsByCharWithoutReducerAPI = (search) => {
  // const { vessel = '', offset = 0 } = data || {}
  return apiGet(`/api/vessel/getAllVessel`, {
    vesselName: search,
    skipUserId: true,
  });
};

export function portsByCharAPI(search) {
  return apiGet(`/api/port/getAllPort`, {
    searchTerm: search,
    skipPagination: true,
  });
}

export function addMultiFleetAPI(data) {
  return apiPost(`/api/fleet/multiple`, data);
}

export function addFleetAPI(data) {
  return apiPost(`/api/fleet`, data);
}

export function changeAutoVesselDetailsAPI(data) {
  return apiPost(`/api/vesselManager/changeAutoVesselDetails`, data)
}

export function updateVesselManagerAPI(data) {
  return apiPost(`/api/vesselManager`, data);
}
export function getVesselManagerAPI(data) {
  return apiGet(`/api/vesselManager/getVesselManagerList`, data);
}

export function updateFleetDataAPI(data) {
  return apiPut(`/api/fleet/` + data._id, data);
}

export function updateLiveSharingAPI(data) {
  return apiPost(`/api/fleet/livesharing/${data.fleetId}/${data?.liveShare}`);
}

export function getSingleFleetDataAPI(fleetId, data) {
  return apiGet(`/api/fleet/` + fleetId, data);
}


export function getEmailsFleetListAPI(data) {
  return apiGet(`/api/vesselManager/getAutoEmailsVesselList`, data);
}
export function getAutoEmailsVesselListAPI(data) {
  return apiGet(`/api/vesselManager/getAutoEmailsVesselList`, data);
}

export function getVesselsWithIdAPI(vesselId, isExtra = false) {
  return apiGet(`/api/vessel/${vesselId}`);
}

export function saveToFleetAPI(data) {
  return apiPost(`/api/v1/saveToFleet`, data);
}

export function getPortDistanceByPortListAPI(portData) {
  // const data = {
  //     portList,
  //     userId: getCurrentUserId()
  // }
  // return apiGet(`/api/v1/getPortDistance`, data)
  const data = {
    ...portData,
    userId: getCurrentUserId(),
  };
  return apiPost(`/api/portDistance/calculate/portDistance`, data);
}

export function getPortDistanceForCargoAnalysisAPI(portData) {
  const data = {
    ...portData,
    userId: getCurrentUserId(),
  };
  return apiPost(`/api/portDistance/calculate/portDistanceCargoAnalysis`, data);
}

export function getPortDistanceMatrixAPI(portData, extra) {
  const data = {
    ...extra,
    routeList: portData,
    userId: getCurrentUserId(),
  };
  return apiPost(`/api/portDistance/calculate/distanceMatrix`, data);
}

export function getCustomDistanceAPI(data) {
  return apiPost(`/api/portDistance/calculate/getCustomDistance`, data);
}


// export function getNewPortDistanceByPortListAPI(portData) {
//     const data = {
//         ...portData,
//         userId: getCurrentUserId()
//     }
//     return apiPost(`/api/v1/getPortDistance`, data)
// }

export function updateDistanceAPI(data) {
  return apiPut(`/api/v1/updateDistance`, data);
}

export function savePortDistanceAPI(data) {
  return apiPost(`/api/v1/savePortDistance`, {
    ...data,
    userId: getCurrentUserId(),
  });
}

export function getCanalNameByUserAPI(data) {
  return apiGet(`/api/v1/getCanalNameByUser?id=${getCurrentUserId()}`);
}

export function userPortNotesAPI(data) {
  return apiGet(`/api/v1/userPortNotes`, data);
}

export function setUSerPortCanalAPI(data) {
  return apiPost(`/api/v1/canal?canalName=${data}`);
}

export function resetDistanceAPI(portData) {
  const data = {
    ...portData,
    userId: getCurrentUserId(),
  };
  return apiGet(`/api/portDistance/calculate/resetDistance`, data);
}

// export function updateFuelPriceAPI(fuelType, data) {
//   return apiPut(`/api/v1/updateFuelPrice?fuelType=${fuelType}`, data);
// }

export function userFleetsAPI(data) {
  return apiGet(`/api/fleet/getAllFleet`, data);
}

export function userFleetDataCopyAPI(data) {
  return apiPost(`/api/vesselManager/userFleetDataCopy`, data);
}

export function allSavedResultsAPI(data = {}) {
  let inititalData = { limit: 50, offset: 1 };
  return apiGet(`/api/calculatedCost/getAllCalculatedCost`, {
    ...inititalData,
    ...data,
  });
}

export function saveCalculatedCostResultAPI(data) {
  return apiPost(`/api/calculatedCost`, data);
}

export function saveResultByIdAPI(id) {
  return apiGet(`/api/calculatedCost/${id}`);
}

export function allResultsByVesselCharAPI(vessel) {
  return apiGet(
    `/api/v1/result/allResultsByVesselChar?offset=1&vessel=${vessel}`
  );
}

export function deleteSavedResultByIdAPI(id) {
  return apiDelete(`/api/calculatedCost/${id}`);
}

export function allVoyageResultsByCharAPI(data) {
  return apiGet(`/api/v1/result/allVoyageResultsByChar`, data);
}

export function allPortRegionsAPI() {
  return apiGet(`/api/portRegion/getAllPortRegions`, { skipId: true });
}

export function createVesselVesselAPI(data) {
  return apiPost(`/api/vesselVessel/createVesselVessel`, data);
}

export function getGeneralMasterDataAPI(type) {
  return apiGet(`/api/generalMaster/getData?type=${type}`);
}
export function getAllCargoAPI(data) {
  return apiPost(`/api/portDistance/getAllCargo?limit=${data.limit ?? 15}&page=${data.page ?? 1}`);
}
export function getAllCargoContractAPI(params, query) {
  const searchParams = new URLSearchParams();

  Object.entries(query).forEach(([key, value]) => {
    if (value !== undefined && value !== null) {
      searchParams.append(key, String(value));
    }
  });

  const id = params?.id || params?.organizationId || (query?.access === "private" ? getCurrentUserId() : "");
  const url = `/api/contract/get-cargo-contract/${id}?${searchParams.toString()}`;
  return apiGet(url);
}

export function getAllVesselContractAPI(params, query) {
  const searchParams = new URLSearchParams();

  Object.entries(query).forEach(([key, value]) => {
    if (value !== undefined && value !== null) {
      searchParams.append(key, String(value));
    }
  });

  const id = params?.id || params?.organizationId || (query?.access === "private" ? getCurrentUserId() : "");
  const url = `/api/contract/get-vessel-contract/${id}?${searchParams.toString()}`;
  return apiGet(url);
}

export function getAllEstimateContractAPI(params, query) {
  const searchParams = new URLSearchParams();

  Object.entries(query).forEach(([key, value]) => {
    if (value !== undefined && value !== null) {
      searchParams.append(key, String(value));
    }
  });

  const id = params?.id || params?.organizationId || (query?.access === "private" ? getCurrentUserId() : "");
  const url = `/api/contract/get-estimate-contract/${id}?${searchParams.toString()}`;
  return apiGet(url);
}
export function getEstimateContractByIdAPI(query) {
  const targetId = typeof query === "object" ? (query?.id || query?._id) : query;
  return apiGet(`/api/contract/get-estimate-contract-by-id/${targetId}`);
}
export function getCargoContractByIdAPI(id) {
  const targetId = typeof id === "object" ? (id?._id || id?.cargoId || id?.contractId || id?.id) : id;
  return apiGet(`/api/contract/get-cargo-contract-by-id/${targetId}`);
}
export function getVesselContractByIdAPI(id) {
  const targetId = typeof id === "object" ? (id?._id || id?.vesselId || id?.contractId || id?.id) : id;
  return apiGet(`/api/contract/get-vessel-contract-by-id/${targetId}`);
}
export function createEstimateContractAPI(data) {
  return apiPost(`/api/contract/create-estimate-contract`, data);
}
const getIdFromParams = (params) => {
  if (!params) return "";
  if (typeof params === "object") {
    return params._id || params.cargoContractId || params.vesselContractId || params.contractId || params.id || "";
  }
  return params;
};

export function updateCargoContractAPI(params, data) {
  return apiPatch(`/api/contract/update-cargo-contract/${getIdFromParams(params)}`, data);
}
export function updateVesselContractAPI(params, data) {
  return apiPatch(`/api/contract/update-vessel-contract/${getIdFromParams(params)}`, data);
}
export function updateEstimateContractAPI(params, data) {
  return apiPatch(`/api/contract/update-estimate-contract/${getIdFromParams(params)}`, data);
}
export function updateVesselAPI(params, data) {
  return apiPatch(`/api/contract/update-vessel/${getIdFromParams(params)}`, data);
}
export function updateCargoAPI(params, data) {
  return apiPatch(`/api/contract/update-cargo/${getIdFromParams(params)}`, data);
}
export function deleteVesselContractAPI(params) {
  return apiDelete(`/api/contract/delete-vessel-contract/${getIdFromParams(params)}`);
}
export function deleteCargoContractAPI(params) {
  return apiDelete(`/api/contract/delete-cargo-contract/${getIdFromParams(params)}`);
}
export function deleteEstimateContractAPI(params) {
  return apiDelete(`/api/contract/delete-estimate-contract/${getIdFromParams(params)}`);
}
export function updatePortDistanceForContractAPI(data) {
  return apiPatch(`/api/contract/update-port-distance`, data);
}
export function updateVesselPortDistanceForContractAPI(data) {
  return apiPatch(`/api/contract/update-vessel-port-distance`, data);
}
export function estimateContractcargoPriceAPI(data) {
  return apiPost(`/api/contract/estimate-cargo-price`, data);
}
export function estimateContractcargoPriceDetailedAPI(data) {
  return apiPost(`/api/contract/estimate-cargo-price-detailed`, data);
}
export function addCargoForEstimateAPI(data) {
  return apiPost(`/api/contract/add-cargo-port/${data?.contractId}`, data);
}
export function deleteCargoForEstimateByIdAPI(data) {
  return apiDelete(`/api/contract/delete-cargo-port/${data?.contractId}/${data?.cargoId}/${data?.contractType}`);
}
export function updateEstimateCostAPI(data) {
  return apiPut(`/api/contract/update-estimate-cost/${data?.contractId}`, data);
}
export function updateEstimateCargoAPI(params, data) {
  return apiPatch(`/api/contract/update-estimate-cargo/${params?._id}`, data);
}

export function resetPortDistanceForContractAPI(data) {
  return apiGet(`/api/contract/reset-distance/${data?.contractId}`);
}


export function getCargoAiUsageAPI(kind = "cargo") {
  return apiGet(`/api/cargoAi/usage`, { kind });
}

export function parseAITextAPI(text, kind = "cargo") {
  return apiPost(`/api/cargoAi/parse`, { text, kind });
}
